import React from 'react';
import { useId } from '@sail/react-aria';
import { createView, view } from '@sail/ui';
import { helmTokens } from '../../theme';
export const Platform = createView((props)=>{
    const id = useId();
    return /*#__PURE__*/ React.createElement(view.svg, {
        width: "30",
        height: "36",
        viewBox: "0 0 30 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `PlatformIconClipPath-${id}`
    }, /*#__PURE__*/ React.createElement(view.path, {
        d: "M17.338 19.548l11.693 6.626c1.292.732 1.292 1.919 0 2.65l-11.693 6.627a5.254 5.254 0 01-4.676 0L.969 28.827c-1.292-.731-1.292-1.918 0-2.65l11.693-6.627a5.255 5.255 0 014.676-.002zm0-19l11.693 6.626c1.292.732 1.292 1.919 0 2.65l-11.693 6.627a5.254 5.254 0 01-4.676 0L.969 9.827c-1.292-.731-1.292-1.918 0-2.65L12.662.55a5.255 5.255 0 014.676-.002z",
        css: {
            fill: `${helmTokens.color.blendBackground}`
        }
    }))), /*#__PURE__*/ React.createElement(view.path, {
        d: "M17.338 19.548l11.693 6.626c1.292.732 1.292 1.919 0 2.65l-11.693 6.627a5.254 5.254 0 01-4.676 0L.969 28.827c-1.292-.731-1.292-1.918 0-2.65l11.693-6.627a5.255 5.255 0 014.676-.002zm0-19l11.693 6.626c1.292.732 1.292 1.919 0 2.65l-11.693 6.627a5.254 5.254 0 01-4.676 0L.969 9.827c-1.292-.731-1.292-1.918 0-2.65L12.662.55a5.255 5.255 0 014.676-.002z",
        css: {
            fill: `${helmTokens.color.blendBackground}`
        }
    }), /*#__PURE__*/ React.createElement(view.path, {
        d: "M17.338 10.548l11.693 6.626c1.292.732 1.292 1.919 0 2.65l-11.693 6.627a5.254 5.254 0 01-4.676 0L.969 19.827c-1.292-.731-1.292-1.918 0-2.65l11.693-6.627a5.255 5.255 0 014.676-.002z",
        css: {
            fill: `${helmTokens.color.blendForeground}`
        }
    }), /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#PlatformIconClipPath-${id})`
    }, /*#__PURE__*/ React.createElement(view.path, {
        d: "M17.338 10.548l11.693 6.626c1.292.732 1.292 1.919 0 2.65l-11.693 6.627a5.254 5.254 0 01-4.676 0L.969 19.827c-1.292-.731-1.292-1.918 0-2.65l11.693-6.627a5.255 5.255 0 014.676-.002z",
        css: {
            fill: `${helmTokens.color.blendIntersection}`
        }
    })));
});

//# sourceMappingURL=Platform.js.map